export const garmentTypesColumns = [
  { id: 'nombre', label: 'Nombre', type: 'text', sortable: true, required: true },
  { id: 'descripcion', label: 'Descripción', type: 'text', sortable: true, required: false },
  { id: 'peso', label: 'Peso (g)', type: 'number', sortable: true, required: true },
  { 
    id: 'planta', 
    label: 'Planta', 
    type: 'select', 
    sortable: true, 
    required: true,
    options: [] // Se llenarán dinámicamente desde el componente padre
  },
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    sortable: true,
    required: true,
    options: [
      { value: 'Activo', label: 'Activo' },
      { value: 'Inactivo', label: 'Inactivo' },
    ],
  },
];

export const columnsExcel = {
  nombre: 'Nombre',
  peso: 'Peso (g)',
  'planta.nombre': 'Planta',
  estado: 'Estado',
  createdAt: 'Fecha de Creación',
  updatedAt: 'Fecha de Actualización',
};
